// Reducer para el Administrador Central de Cálculos (ACC)

const initialState = {
  // Estados de loading
  isLoading: false,
  isLoadingParameters: false,
  isLoadingUsuraRates: false,

  // Datos
  parameters: {
    data: [],
    total: 0,
  },
  usuraRates: {
    data: [],
    total: 0,
  },

  // Estados de error
  error: null,
  parametersError: null,
  usuraRatesError: null,

  // Estados de éxito
  lastOperationSuccess: false,
  lastOperationType: null, // 'create', 'update', o null
};

export default function accReducer(state = initialState, action) {
  switch (action.type) {
    // Actions para loading states
    case "SET_ACC_LOADING":
      return {
        ...state,
        isLoading: action.isLoading,
      };

    // Actions para parámetros ACC
    case "START_GET_ACC_PARAMETERS":
      return {
        ...state,
        isLoadingParameters: true,
        parametersError: null,
      };

    case "GET_ACC_PARAMETERS_SUCCESS":
      return {
        ...state,
        isLoadingParameters: false,
        parameters: action.data || { data: [], total: 0 },
        parametersError: null,
      };

    case "GET_ACC_PARAMETERS_FAIL":
      return {
        ...state,
        isLoadingParameters: false,
        parametersError: action.error,
        lastOperationSuccess: false,
        lastOperationType: null,
      };

    // Actions para tasas de usura
    case "START_GET_USURA_RATES":
      return {
        ...state,
        isLoadingUsuraRates: true,
        usuraRatesError: null,
      };

    case "GET_USURA_RATES_SUCCESS":
      return {
        ...state,
        isLoadingUsuraRates: false,
        usuraRates: action.data || { data: [], total: 0 },
        usuraRatesError: null,
      };

    case "GET_USURA_RATES_FAIL":
      return {
        ...state,
        isLoadingUsuraRates: false,
        usuraRatesError: action.error,
        lastOperationSuccess: false,
        lastOperationType: null,
      };

    // Actions para crear/actualizar tasas de usura
    case "START_CREATE_OR_UPDATE_USURA_RATE":
      return {
        ...state,
        isLoading: true,
        error: null,
        lastOperationSuccess: false,
      };

    case "CREATE_OR_UPDATE_USURA_RATE_SUCCESS":
      return {
        ...state,
        isLoading: false,
        error: null,
        lastOperationSuccess: true,
        lastOperationType: action.operationType,
      };

    case "CREATE_OR_UPDATE_USURA_RATE_FAIL":
      return {
        ...state,
        isLoading: false,
        error: action.error,
        lastOperationSuccess: false,
        lastOperationType: null,
      };

    // Actions para limpiar errores
    case "CLEAR_ACC_ERROR":
      return {
        ...state,
        error: null,
        parametersError: null,
        usuraRatesError: null,
        lastOperationSuccess: false,
        lastOperationType: null,
      };

    default:
      return state;
  }
}

// Exportar el reducer con el nombre que espera el sistema
export const reducer = accReducer;
